import React, { createContext, useContext, useState } from 'react';

const AlertContext = createContext();

export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
    const [alert, setAlert] = useState({ show: false, message: '', severity: 'info' });

    const triggerAlert = (message, severity = 'info', duration = 3000) => {
        setAlert({ show: true, message, severity });
        setTimeout(() => {
            setAlert({ show: false, message: '', severity: 'info' });  // Auto close after duration
        }, duration);
    };

    const closeAlert = () => {
        setAlert(prev => ({ ...prev, show: false }));
    };

    return (
        <AlertContext.Provider value={{ alert, triggerAlert, closeAlert }}>
            {children}
        </AlertContext.Provider>
    );
};
